import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

interface IProposalProgressBarStepProps {
  title: string
  step: number
  activeStep: number
  stepDate?: string
}

const ProposalProgressBarStep = ({
  title,
  step,
  activeStep,
  stepDate,
}: IProposalProgressBarStepProps) => {
  return (
    <span
      className={clsx(s.progressStep, {
        [s.progressStepActive]: step <= activeStep,
      })}
      data-title={title}
    >
      <div className={s.date}>{stepDate}</div>
    </span>
  )
}

export default ProposalProgressBarStep
